var exports = {
  "Kk": "InviteEmbed.module__icon___VTVFRE",
  "EU": "InviteEmbed.module__iconFallback___VTVFRE",
  "C1": "InviteEmbed.module__titleRowWithIcon___VTVFRE",
  "gn": "InviteEmbed.module__titleContainer___VTVFRE",
  "Qw": "InviteEmbed.module__titleText___VTVFRE",
  "fH": "InviteEmbed.module__headerInvite___VTVFRE",
  "dT": "InviteEmbed.module__inviteWrapper___VTVFRE",
  "M1": "InviteEmbed.module__stats___VTVFRE",
  "dJ": "InviteEmbed.module__stat___VTVFRE",
  "gW": "InviteEmbed.module__statDot___VTVFRE",
  "rR": "InviteEmbed.module__statDotOnline___VTVFRE",
  "rb": "InviteEmbed.module__statDotMembers___VTVFRE",
  "KA": "InviteEmbed.module__statText___VTVFRE",
};

module.exports = exports;
